













































































import { defineComponent, reactive, computed } from '@vue/composition-api';
import { useRouter } from '@ideavivat/vivat-2';

import getMediaTypes from '@/gql/getMediaTypes.gql';
import getMedias from '@/gql/getMedias.gql';
import setActiveMedia from '@/gql/setActiveMedia.gql';
import deleteMedia from '@/gql/deleteMedia.gql';
import { useQuery, useResult, useMutation } from '@vue/apollo-composable';

import media from '@/table/media';

import CommonMediaTypeSelector from '@/components/Selector/CommonMediaTypeSelector.vue';
import CommonConfirmDialog from '@/components/Dialog/CommonConfirmDialog.vue';
import { ToggleButton } from 'vue-js-toggle-button';

const List = defineComponent({
  setup() {
    /* ==== Get media type ==== */
    const { result: mediaTypesResult, loading } = useQuery(getMediaTypes);
    const mediaTypes = useResult(mediaTypesResult, {}, (data) => data.mediaTypes);
    // const mediaTypesValue = mediaTypes.value;
    // ============================== //

    const search = reactive({
      text: '',
      type: '',
    });

    function getFileExtensionFromMediaType(mediaType: string) {
      if (mediaType === 'วิดิโอ') return 'youtube';
      if (mediaType === 'นิตยสาร') return 'jpeg';
      if (mediaType === 'หนังสือ') return 'pdf';
      return '';
    }

    // ==== Mutate Active Item ==== //
    const changeActive = reactive({
      id: undefined,
      status: false,
    });

    const activeMutation = useMutation(
      setActiveMedia,
      () => ({
        variables: {
          ...changeActive,
        },
        refetchQueries: ['getMedias'],
      }),
    );

    function setActiveStatus(id: any, status: boolean) {
      changeActive.id = id;
      changeActive.status = status;
      activeMutation.mutate();
    }
    // ============================= //

    // ==== Set message to display on delete dialog ==== //
    const deleteItem = reactive({
      id: '',
      name: '',
    });
    function setDisplayItem(item: any) {
      deleteItem.id = item.id;
      deleteItem.name = item.name;
    }
    // ==== Create delete Mutation ==== //
    const deleteMutation = useMutation(
      deleteMedia,
      () => ({
        variables: {
          id: deleteItem.id,
        },
        refetchQueries: ['getMedias'],
      }),
    );

    // ==== Redirect to view item page ==== //
    const { router } = useRouter();
    function viewItem(item: any) {
      router.push({ name: 'MediaView', params: { mediaId: item.item?.id } });
    }

    // ==== Use to search Media ==== //
    const mediaListVariables = computed(() => {
      const vars: {[key: string]: any} = {
        searchName: undefined,
        filterMediaType: undefined,
      };
      if (search.text) {
        vars.searchName = `%${search.text}%`;
      }
      if (search.type) {
        vars.filterMediaType = search.type;
      }
      return vars;
    });

    return {
      mediaTypes,
      getMediasQuery: getMedias,
      mediaTableOption: media,
      getMediasResult: (data: any) => data.medias,
      search,
      getFileExtensionFromMediaType,
      loading,
      setActiveStatus,
      deleteItem,
      setDisplayItem,
      deleteMutation,
      mediaListVariables,
      viewItem,
    };
  },
  components: {
    CommonMediaTypeSelector,
    CommonConfirmDialog,
    ToggleButton,
  },
  props: {
    role: {},
  },
});

export default List;
